import styled from 'styled-components';
import { infoStore } from '../../store/infoStore';
import { ImageUtils } from '../../utils/ImageUtils';
import { mobileQuery } from '../../utils';

type NumberTicketProps = {
  isMainEvent?: boolean;
};

export const NumberTicket = ({ isMainEvent = true }: NumberTicketProps) => {
  const { mainInfo, sideInfo } = infoStore();
  const info = isMainEvent ? mainInfo : sideInfo;

  return (
    <TicketContainer>
      <Ticket src={isMainEvent ? ImageUtils.CardMain : ImageUtils.CardSide} />
      <TicketTextContainer>
        <Inner>
          <Title>오프라인 {isMainEvent ? '메인' : '사이드'} 이벤트 참가 정보</Title>
          <NumberTitleContainer>
            <NumberTitle>참가자 번호</NumberTitle>
          </NumberTitleContainer>
          <TicketText>{info.ticketNo}</TicketText>
          <WaringTextContainer>
            <WaringText>
              QR코드는 {isMainEvent ? '5월 17일 00시' : '5월 16일 00시'} 부터 보여집니다.
            </WaringText>
          </WaringTextContainer>
        </Inner>
      </TicketTextContainer>
    </TicketContainer>
  );
};

const Title = styled.h3`
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.6);
  margin-top: 13px;
  margin-bottom: 9px;

  ${mobileQuery} {
    margin-top: 0;
    font-size: 12px;
    line-height: 16px;
  }
`;

const NumberTitleContainer = styled.div`
  width: 430px;
  height: 56px;
  margin: 0 auto;

  background: rgba(0, 0, 0, 0.1);
  border-top: 1px solid #000000;

  ${mobileQuery} {
    width: 215px;
    height: 26px;
  }
`;

const NumberTitle = styled.h4`
  font-weight: 800;
  font-size: 24px;
  line-height: 56px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #000000;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 26px;
  }
`;

const WaringTextContainer = styled.div`
  text-align: center;
`;

const WaringText = styled.p`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  text-align: center;

  color: rgba(0, 0, 0, 0.6);
  border-top: 1px solid rgba(0, 0, 0, 0.6);
  display: inline-block;
  margin-top: 20px;

  ${mobileQuery} {
    padding-top: 5px;
    margin-top: 0px;
    font-size: 12px;
    line-height: 16px;
  }
`;

const Ticket = styled.img`
  position: relative;
`;

const TicketContainer = styled.div`
  display: flex;
  position: relative;
`;

const TicketTextContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Inner = styled.div``;

const TicketText = styled.p`
  font-weight: bold;
  font-weight: 700;
  font-size: 128px;
  line-height: 144px;
  color: #000000;
  text-align: center;

  ${mobileQuery} {
    font-size: 64px;
    line-height: 70px;
    padding-bottom: 5px;
  }
`;
